<div class="section-header">
    <h2>{{ 'predefinedPathways.form.courses' | translate }}</h2>
    <p-button
        [label]="'predefinedPathways.courses.add' | translate"
        icon="pi pi-plus"
        [outlined]="true"
        size="small"
        data-test="predefined-pathways-courses-add"
        (onClick)="add.emit()"
    />
</div>

@if (courses().length > 0) {
    <div cdkDropList class="course-list" (cdkDropListDropped)="onDrop($event)">
        @for (course of courses(); track course.id) {
            <div cdkDrag class="course-item">
                <div class="arrows">
                    <button
                        type="button"
                        class="arrow"
                        [disabled]="$first"
                        [attr.data-test]="'predefined-pathways-courses-move-up-' + course.id"
                        (click)="moveCourse($index, -1)"
                    >
                        <i class="pi pi-chevron-up"></i>
                    </button>
                    <button
                        type="button"
                        class="arrow"
                        [disabled]="$last"
                        [attr.data-test]="'predefined-pathways-courses-move-down-' + course.id"
                        (click)="moveCourse($index, 1)"
                    >
                        <i class="pi pi-chevron-down"></i>
                    </button>
                </div>
                <span class="name">{{ course.name }}</span>
                <button type="button" class="remove" [attr.data-test]="'predefined-pathways-courses-remove-' + course.id" (click)="remove.emit(course.id)">
                    <i class="pi pi-trash"></i>
                </button>
            </div>
        }
    </div>
} @else {
    <p class="empty">{{ 'predefinedPathways.courses.empty' | translate }}</p>
}
